import { API_PATHS } from "../constants/api-paths";
import { COMMON_SSO_MOBILE } from "../constants/sso";
import { createCacheAsync } from "@repo/shared-utils/cache";
import { decryptLocalStorageMobileNo } from "@repo/shared-utils/crypto";
import { encryptedRequest } from "../core/api.client";

export interface IDoacResposnse {
  productWiseTenorsList: ITenoreListItem[];
  roi: IRoiListItem[];
  ruralTenors: { selfemp: ITenoreListItem[]; sal: ITenoreListItem[] };
  urbanTenors: { selfemp: ITenoreListItem[]; sal: ITenoreListItem[] };
}

export interface IRoiListItem {
  loanAmtFrom: string;
  loanAmtTo: string;
  value: string;
  extId: number;
  minTenor: string;
  maxTenor: string;
}

interface ITenoreListItem {
  minTenor: number;
  maxTenor: number;
  minLoanAmount: number;
  maxLoanAmount: number;
  allowedTenor: number[];
  plist: number[];
  pname: string;
}

export const getDoacValidateDetails = async (product: string): Promise<IDoacResposnse> => {
  const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
  const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
  try {
    const response = await createCacheAsync(
      `POST-${API_PATHS.doacValidate}-${mobileNo}`,
      encryptedRequest<IDoacResposnse>,
      {
        method: "POST",
        url: API_PATHS.doacValidate,
        data: {
          mobileNo,
          product,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return {} as IDoacResposnse;
  }
};
